import { reducer } from 'utils';
import { types } from './website.actions';

const handlers = {
  [types.FETCH_WEBSITE](state, action) {
    return { ...state, ...action.website };
  },


  [types.FETCH_WEBSITE_REQUEST](state, action) {
    return { ...state, isFetching: true };
  },


  [types.FETCH_WEBSITE_SECTION](state, action) {
    state.sections = state.sections.map(section => {
      if (section.type === action.sectionType) {
        return { ...section, data: action.sectionData };
      } else {
        return section;
      }
    });

    return { ...state };
  },


  [types.FETCH_WEBSITE_SUCCESS](state, action) {
    return { ...state, isFetching: false };
  },


  [types.SUBMIT_CONTACT](state, action) {
    return { ...state, contactConfirm: action.result };
  },


  [types.UI_ACTION](state, action) {
    return { ...state, ui: action.data };
  },
};

export default reducer(handlers);


// WEBPACK FOOTER //
// ./src/website/website.reducer.js